/** external */
import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

/** internal */
import {
  WORKSHEET_MODES,
  MODE_TEACHER_CREATE,
} from "Worksheet/modules/WorksheetConstants";
import { getOrganizationResourceFromCache } from "Worksheet/modules/WorksheetGraphqlHelpers";

/** relative */
import QuestionDetails from "./QuestionDetails";

const QuestionDetailsWrapper = props => {
  const {
    mode,
    setQuestionRef,
    portalType,
    showWorksheetAssistant,
    questionResourceId,
    questionIndex,
    sectionId,
    sourceFrom,
    classSubjects,
    assessmentId,
    creationMode,
    unitPlanTemplateId,
    t,
    getLearningGoalsMappingWrapper,
    worksheetDetailsRef,
    courseId,
    selectedCourse,
    unitPlanId,
    isFromUnitPlan,
    isDraft,
    isActive,
    isSeparatorQuestion,
    spaceContainerInBetweenRef,
    isAIAssessmentToolsOpen,
    getAddButton,
    addQuestionsInBetweenProps,
    parentItemId,
    question,
    isQueriesV2Enabled,
  } = props;

  // If Queries V2 is enabled, we use the question prop directly
  // Otherwise, we fetch the question data from the cache
  let questionData = {};
  //WORKSHEET_RESTRUCTURING: Use question directly when queriesV2 is enabled
  if (!isQueriesV2Enabled) {
    questionData = getOrganizationResourceFromCache(questionResourceId, true);
  } else {
    questionData = question;
  }
  return (
    <QuestionDetails
      mode={mode}
      setQuestionRef={setQuestionRef}
      portalType={portalType}
      showWorksheetAssistant={showWorksheetAssistant}
      questionResourceId={questionResourceId}
      questionIndex={questionIndex}
      sectionId={sectionId}
      sourceFrom={sourceFrom}
      classSubjects={classSubjects}
      assessmentId={assessmentId}
      creationMode={creationMode}
      unitPlanTemplateId={unitPlanTemplateId}
      t={t}
      getLearningGoalsMappingWrapper={getLearningGoalsMappingWrapper}
      questionData={questionData}
      worksheetDetailsRef={worksheetDetailsRef}
      courseId={courseId}
      selectedCourse={selectedCourse}
      unitPlanId={unitPlanId}
      isFromUnitPlan={isFromUnitPlan}
      isDraft={isDraft}
      isActive={isActive}
      isSeparatorQuestion={isSeparatorQuestion}
      spaceContainerInBetweenRef={spaceContainerInBetweenRef}
      isAIAssessmentToolsOpen={isAIAssessmentToolsOpen}
      getAddButton={getAddButton}
      addQuestionsInBetweenProps={addQuestionsInBetweenProps}
      parentItemId={parentItemId}
      isQueriesV2Enabled={isQueriesV2Enabled}
    />
  );
};

const mapStateToProps = state => {
  const activeQuestionId = _.get(state, "worksheet.activeQuestion");
  return {
    activeQuestionId,
  };
};

export default connect(mapStateToProps, null)(QuestionDetailsWrapper);

QuestionDetailsWrapper.propTypes = {
  mode: PropTypes.oneOf(WORKSHEET_MODES),
  setQuestionRef: PropTypes.func,
  sectionId: PropTypes.string,
  questionResourceId: PropTypes.string,
  questionIndex: PropTypes.number,
  sourceFrom: PropTypes.string,
  classSubjects: PropTypes.arrayOf(PropTypes.object),
  creationMode: PropTypes.string,
  unitPlanTemplateId: PropTypes.string,
  assessmentId: PropTypes.string,
  t: PropTypes.func,
  portalType: PropTypes.string,
  showWorksheetAssistant: PropTypes.bool,
  courseId: PropTypes.string,
  selectedCourse: PropTypes.object,
  unitPlanId: PropTypes.string,
  isFromUnitPlan: PropTypes.bool,
  isDraft: PropTypes.bool,
  isActive: PropTypes.bool,
  isSeparatorQuestion: PropTypes.bool,
  spaceContainerInBetweenRef: PropTypes.shape({
    current: PropTypes.instanceOf(HTMLElement),
  }),
  getAddButton: PropTypes.func,
  addQuestionsInBetweenProps: PropTypes.object,
  parentItemId: PropTypes.string,
  isQueriesV2Enabled: PropTypes.bool,
};

QuestionDetailsWrapper.defaultProps = {
  mode: MODE_TEACHER_CREATE,
  setQuestionRef: _.noop,
  t: _.noop,
  selectedCourse: {},
  isFromUnitPlan: false,
  isDraft: false,
  isSeparatorQuestion: false,
  spaceContainerInBetweenRef: null,
  getAddButton: _.noop,
  addQuestionsInBetweenProps: {},
  isQueriesV2Enabled: false,
  question: {},
};
